<div *ngIf="content$ | async as appContent">
	<form [formGroup]="guardianForm" ngxsForm="guardianState.guardianForm">
		<div formArrayName="guardians" class="nha-sa-section print-padding">
			<div *ngFor="let guardian of guardians.controls; let g = index" [formGroupName]="g">
				<div class="nha-sa-section-header">
					<span *ngIf="guardian.get('firstName').value.trim() && guardian.get('lastName').value.trim()">
						{{ guardian.get('firstName').value + ' ' + guardian.get('lastName').value }}
					</span>
					<span *ngIf="!guardian.get('firstName').value.trim() || !guardian.get('lastName').value.trim()">
						{{ appContent.resourceStrings['nha.sa.parentguardianheader'] }}
						<span class="remove-for-print">{{ g + 1 }}</span>
					</span>
					<span class="nha-pattern-dots"></span>
				</div>
				<div class="nha-row print-row">
					<div class="nha-form-group nha-gr-12 nha-gr-6@sm nha-gr-5@md">
						<label for="guardianFirstName{{ g }}"
							><span class="nha-required" aria-hidden="true">*</span> {{ appContent.resourceStrings['nha.sa.guardianfirstname'] }}</label
						>
						<input
							id="guardianFirstName{{ g }}"
							class="nha-form-control"
							type="text"
							formControlName="firstName"
							(change)="g === 0 ? updateLeadData() : ''"
							aria-required="true"
						/>
						<div
							*ngIf="getControl(g, 'firstName').invalid && (getControl(g, 'firstName').dirty || getControl(g, 'firstName').touched)"
							class="nha-form-error-desc"
						>
							<span *ngIf="getControl(g, 'firstName').errors.required">{{ appContent.resourceStrings['nha.sa.errorfirstname'] }}</span>
							<span *ngIf="getControl(g, 'firstName').errors.maxlength">{{ appContent.resourceStrings['nha.sa.errorlongvalue'] }}</span>
							<span *ngIf="getControl(g, 'firstName').errors.unsafeValue">{{ appContent.resourceStrings['nha.sa.errorinvalidcharacter'] }}</span>
						</div>
					</div>
					<div class="nha-form-group nha-gr-12 nha-gr-6@sm nha-gr-5@md nha-suffix-2@md lastname-print">
						<label for="guardianLastName{{ g }}"
							><span class="nha-required" aria-hidden="true">*</span> {{ appContent.resourceStrings['nha.sa.guardianlastname'] }}</label
						>
						<input
							id="guardianLastName{{ g }}"
							class="nha-form-control"
							type="text"
							formControlName="lastName"
							(change)="g === 0 ? updateLeadData() : ''"
							aria-required="true"
						/>
						<div
							*ngIf="getControl(g, 'lastName').invalid && (getControl(g, 'lastName').dirty || getControl(g, 'lastName').touched)"
							class="nha-form-error-desc"
						>
							<span *ngIf="getControl(g, 'lastName').errors.required">{{ appContent.resourceStrings['nha.sa.errorlastname'] }}</span>
							<span *ngIf="getControl(g, 'lastName').errors.maxlength">{{ appContent.resourceStrings['nha.sa.errorlongvalue'] }}</span>
							<span *ngIf="getControl(g, 'lastName').errors.unsafeValue">{{ appContent.resourceStrings['nha.sa.errorinvalidcharacter'] }}</span>
						</div>
					</div>
				</div>
				<div class="print-row">
					<div class="nha-row">
						<div class="nha-form-group nha-gr-12 nha-gr-6@sm nha-suffix-6@sm nha-gr-5@md nha-suffix-7@md email-print">
							<label for="guardianEmail{{ g }}"
								><span class="nha-required" aria-hidden="true">*</span> {{ appContent.resourceStrings['nha.sa.guardianemail'] }}</label
							>
							<input
								id="guardianEmail{{ g }}"
								class="nha-form-control"
								type="email"
								formControlName="email"
								(change)="g === 0 ? updateLeadData() : ''"
							/>
							<div
								*ngIf="getControl(g, 'email').invalid && (getControl(g, 'email').dirty || getControl(g, 'email').touched)"
								class="nha-form-error-desc"
							>
								<span *ngIf="getControl(g, 'email').errors.required">{{ appContent.resourceStrings['nha.sa.erroremail'] }}</span>
								<span *ngIf="getControl(g, 'email').errors.maxlength">{{ appContent.resourceStrings['nha.sa.errorlongvalue'] }}</span>
								<span *ngIf="getControl(g, 'email').errors.pattern">{{ appContent.resourceStrings['nha.sa.errorinvalidemail'] }}</span>
							</div>
						</div>
						<div class="nha-form-group nha-gr-12 nha-gr-6@sm nha-suffix-6@sm nha-gr-5@md nha-suffix-7@md remove-for-print">
							<label for="guardianEmailConfirm{{ g }}"
								><span class="nha-required" aria-hidden="true">*</span> {{ appContent.resourceStrings['nha.sa.guardianemailconfirm'] }}</label
							>
							<input
								id="guardianEmailConfirm{{ g }}"
								class="nha-form-control"
								type="email"
								formControlName="emailConfirm"
								(change)="g === 0 ? updateLeadData() : ''"
							/>
							<div
								*ngIf="getControl(g, 'emailConfirm').invalid && (getControl(g, 'emailConfirm').dirty || getControl(g, 'emailConfirm').touched)"
								class="nha-form-error-desc"
							>
								<span *ngIf="getControl(g, 'emailConfirm').errors.required">{{ appContent.resourceStrings['nha.sa.erroremail'] }}</span>
								<span *ngIf="getControl(g, 'emailConfirm').errors.mismatchEmail">{{
									appContent.resourceStrings['nha.sa.errorinvalidemailconfirm']
								}}</span>
							</div>
						</div>
					</div>
					<div class="nha-row">
						<div class="nha-form-group nha-gr-12 nha-gr-6@sm nha-gr-5@md primaryphone-print">
							<label for="guardianPrimaryPhone{{ g }}"
								><span class="nha-required" aria-hidden="true">*</span>
								{{ appContent.resourceStrings['nha.sa.guardianprimaryphonenumber'] }}</label
							>
							<input
								id="guardianPrimaryPhone{{ g }}"
								class="nha-form-control"
								type="tel"
								formControlName="primaryPhone"
								appPhone
								maxlength="14"
								(change)="g === 0 ? updateLeadData() : ''"
								aria-required="true"
							/>
							<div class="nha-form-error-desc">
								{{ appContent.resourceStrings['nha.sa.errorprimaryphonenumber'] }}
							</div>
						</div>
						<div *ngIf="!guardian.get('secondaryPhone').value" class="nha-gr-12 nha-gr-6@sm nha-gr-7@md">
							<a
								(click)="guardian.get('secondaryPhone').setValue(' ')"
								(keydown.enter)="guardian.get('secondaryPhone').setValue(' ')"
								class="nha-sa-phone-link nha-inline-block"
								tabindex="0"
							>
								<div class="remove-for-print">
									<span class="fa fa-plus-circle" aria-hidden="true"></span>
									{{ appContent.resourceStrings['nha.sa.addsecondaryphonenumber'] }}
								</div>
							</a>
						</div>
						<div
							*ngIf="guardian.get('secondaryPhone').value"
							class="nha-form-group nha-gr-12 nha-gr-6@sm nha-gr-5@md nha-suffix-2@md remove-for-print"
						>
							<div class="nha-form-group">
								<label for="guardianSecondaryPhone{{ g }}">
									{{ appContent.resourceStrings['nha.sa.secondaryphonenumber'] }}
								</label>
								<input
									id="guardianSecondaryPhone{{ g }}"
									class="nha-form-control"
									type="tel"
									formControlName="secondaryPhone"
									appPhone
									maxlength="14"
								/>
								<div class="nha-form-error-desc">
									{{ appContent.resourceStrings['nha.sa.errorprimaryphonenumber'] }}
								</div>
							</div>
							<a
								(click)="removeSecondaryPhone(g)"
								(keydown.enter)="removeSecondaryPhone(g)"
								class="nha-warning-link nha-sa-phone-link nha-inline-block"
								tabindex="0"
							>
								<span class="fa fa-trash-o" aria-hidden="true"></span>
								{{ appContent.resourceStrings['nha.sa.removesecondaryphonenumber'] }}
							</a>
						</div>
					</div>
				</div>
				<hr />
				<div *ngIf="g > 0" class="nha-row">
					<div class="nha-gr-12">
						<div class="nha-form-group nha-inline-block">
							<input
								id="guardianSameAddress{{ g }}"
								(change)="sameHouseholdChange(g)"
								class="nha-input-checkbox"
								type="checkbox"
								formControlName="sameHousehold"
							/>
							<label for="guardianSameAddress{{ g }}">
								<ng-container *ngIf="schoolIsNY">
									{{ appContent.resourceStrings['nha.sa.sameaddressny'] }}
								</ng-container>
								<ng-container *ngIf="!schoolIsNY">
									{{ appContent.resourceStrings['nha.sa.sameaddress'] }}
									<span *ngIf="guardians.controls[0].get('firstName').value && guardians.controls[0].get('lastName').value">
										{{ guardians.controls[0].get('firstName').value + ' ' + guardians.controls[0].get('lastName').value }}
									</span>
									<span *ngIf="!guardians.controls[0].get('firstName').value || !guardians.controls[0].get('lastName').value">
										{{ appContent.resourceStrings['nha.sa.parentguardianheader'] }}
										1
									</span>
								</ng-container>
							</label>
						</div>
					</div>
				</div>
				<h4 *ngIf="schoolIsNY && g === 0">
					{{ appContent.resourceStrings['nha.sa.nyaddressheading'] }}
				</h4>
				<div formGroupName="household">
					<div [hidden]="guardian.get('sameHousehold').value">
						<div class="nha-row">
							<div class="nha-form-group nha-gr-12 nha-gr-6@sm nha-gr-5@md">
								<label for="guardianAddress{{ g }}"
									><span class="nha-required" aria-hidden="true">*</span>
									{{ appContent.resourceStrings['nha.sa.guardianstreetaddress'] }}</label
								>
								<input
									appAddressLookahead
									(setAddress)="getAddress($event, g)"
									(change)="g === 0 ? updateLeadData() : ''"
									formControlName="address"
									id="guardianAddress{{ g }}"
									class="nha-form-control address-input"
									placeholder="{{ appContent.resourceStrings['nha.sa.guardianstreetaddressfieldtext'] }}"
									type="text"
									aria-required="true"
								/>
								<input
									(setAddress)="getAddress($event, g)"
									(change)="g === 0 ? updateLeadData() : ''"
									class="nha-form-control address-input-print"
									type="text"
								/>
								<div
									*ngIf="
										getControl(g, 'household.address').invalid &&
										(getControl(g, 'household.address').dirty || getControl(g, 'household.address').touched)
									"
									class="nha-form-error-desc"
								>
									<span *ngIf="getControl(g, 'household.address').errors.required">
										{{ appContent.resourceStrings['nha.sa.errorguardianstreetaddress'] }}
									</span>
									<span *ngIf="getControl(g, 'household.address').errors.maxlength">
										{{ appContent.resourceStrings['nha.sa.errorlongvalue'] }}
									</span>
									<span *ngIf="getControl(g, 'household.address').errors.unsafeValue">
										{{ appContent.resourceStrings['nha.sa.errorinvalidcharacter'] }}
									</span>
								</div>
							</div>
							<div
								*ngIf="!guardian.get('household.showAddress2').value"
								class="nha-form-group nha-gr-12 nha-gr-6@sm nha-gr-5@md nha-suffix-2@md remove-for-print"
							>
								<a
									(click)="guardian.get('household.showAddress2').setValue(true)"
									(keydown.enter)="guardian.get('household.showAddress2').setValue(true)"
									class="nha-sa-phone-link nha-inline-block"
									tabindex="0"
								>
									<div>
										<span class="fa fa-plus-circle" aria-hidden="true"></span>
										{{ appContent.resourceStrings['nha.sa.addaddressline2'] }}
									</div>
								</a>
							</div>
							<div
								*ngIf="guardian.get('household.showAddress2').value"
								class="nha-form-group nha-gr-12 nha-gr-6@sm nha-gr-5@md nha-suffix-2@md remove-for-print"
							>
								<label for="guardianAddress2{{ g }}"> {{ appContent.resourceStrings['nha.sa.addressline2'] }}</label>
								<input
									(change)="g === 0 ? updateLeadData() : ''"
									formControlName="address2"
									id="guardianAddress2{{ g }}"
									class="nha-form-control"
									placeholder="{{ appContent.resourceStrings['nha.sa.addressline2fieldtext'] }}"
									type="text"
								/>
								<div
									*ngIf="
										getControl(g, 'household.address2').invalid &&
										(getControl(g, 'household.address2').dirty || getControl(g, 'household.address2').touched)
									"
									class="nha-form-error-desc"
								>
									<span *ngIf="getControl(g, 'household.address2').errors.maxlength">
										{{ appContent.resourceStrings['nha.sa.errorlongvalue'] }}
									</span>
									<span *ngIf="getControl(g, 'household.address2').errors.unsafeValue">
										{{ appContent.resourceStrings['nha.sa.errorinvalidcharacter'] }}
									</span>
								</div>
								<a
									(click)="removeSecondaryAddress(g)"
									(keydown.enter)="removeSecondaryAddress(g)"
									class="nha-warning-link nha-sa-phone-link nha-inline-block"
									tabindex="0"
								>
									<span class="fa fa-trash-o" aria-hidden="true"></span>
									{{ appContent.resourceStrings['nha.sa.removesecondaryphonenumber'] }}
								</a>
							</div>
							<div class="nha-clear nha-form-group nha-gr-12 nha-gr-6@sm nha-gr-5@md print-city-width">
								<label for="guardianCity{{ g }}">
									<span class="nha-required" aria-hidden="true">*</span>{{ appContent.resourceStrings['nha.sa.guardiancity'] }}
								</label>
								<input
									id="guardianCity{{ g }}"
									class="nha-form-control"
									type="text"
									formControlName="city"
									(change)="g === 0 ? updateLeadData() : ''"
									aria-required="true"
								/>
								<div
									*ngIf="
										getControl(g, 'household.city').invalid &&
										(getControl(g, 'household.city').dirty || getControl(g, 'household.city').touched)
									"
									class="nha-form-error-desc"
								>
									<span *ngIf="getControl(g, 'household.city').errors.required">
										{{ appContent.resourceStrings['nha.sa.errorguardiancity'] }}
									</span>
									<span *ngIf="getControl(g, 'household.city').errors.maxlength">
										{{ appContent.resourceStrings['nha.sa.errorlongvalue'] }}
									</span>
									<span *ngIf="getControl(g, 'household.city').errors.unsafeValue">
										{{ appContent.resourceStrings['nha.sa.errorinvalidcharacter'] }}
									</span>
								</div>
							</div>
							<div class="nha-form-group nha-input-select nha-gr-6 nha-gr-3@sm nha-gr-2@md print-state-zip-width">
								<label for="guardianState{{ g }}"
									><span class="nha-required" aria-hidden="true">*</span> {{ appContent.resourceStrings['nha.sa.guardianstate'] }}</label
								>
								<select
									id="guardianState{{ g }}"
									class="nha-form-control"
									formControlName="stateCode"
									(change)="g === 0 ? updateLeadData() : ''"
									aria-required="true"
								>
									<option></option>
									<option *ngFor="let state of appContent.states" value="{{ state.code }}">
										{{ state.code }}
									</option>
								</select>
								<div
									*ngIf="
										getControl(g, 'household.stateCode').invalid &&
										(getControl(g, 'household.stateCode').dirty || getControl(g, 'household.stateCode').touched)
									"
									class="nha-form-error-desc"
								>
									<span *ngIf="getControl(g, 'household.stateCode').errors.required">
										{{ appContent.resourceStrings['nha.sa.errorguardianstate'] }}
									</span>
									<span *ngIf="getControl(g, 'household.stateCode').errors.unsafeValue">
										{{ appContent.resourceStrings['nha.sa.errorinvalidcharacter'] }}
									</span>
								</div>
							</div>
							<div class="nha-form-group nha-gr-6 nha-gr-3@sm nha-gr-3@md nha-suffix-2@md print-state-zip-width">
								<label for="guardianZip{{ g }}"
									><span class="nha-required" aria-hidden="true">*</span> {{ appContent.resourceStrings['nha.sa.guardianzipcode'] }}</label
								>
								<input
									id="guardianZip{{ g }}"
									class="nha-form-control"
									type="text"
									formControlName="zipCode"
									appNumberLimitTo="5"
									(change)="g === 0 ? updateLeadData() : ''"
									aria-required="true"
								/>
								<div
									*ngIf="
										getControl(g, 'household.zipCode').invalid &&
										(getControl(g, 'household.zipCode').dirty || getControl(g, 'household.zipCode').touched)
									"
									class="nha-form-error-desc"
								>
									<span *ngIf="getControl(g, 'household.zipCode').errors.required || getControl(g, 'household.zipCode').errors.minlength">
										{{ appContent.resourceStrings['nha.sa.errorguardianzipcode'] }}
									</span>
									<span *ngIf="getControl(g, 'household.zipCode').errors.maxlength">
										{{ appContent.resourceStrings['nha.sa.errorlongvalue'] }}
									</span>
									<span *ngIf="getControl(g, 'household.zipCode').errors.unsafeValue">
										{{ appContent.resourceStrings['nha.sa.errorinvalidcharacter'] }}
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- Current Enrollment Preferences -->
				<div *ngIf="g === 0 && appContent.currentEnrollmentPreferences && this.academicYearApplying === appContent.currentAcademicYear" class="nha-row">
					<hr />
					<legend id="guardianPreferencesQuestion" class="nha-gr-12" aria-describedby="guardianPreferencesTooltip">
						{{ appContent.resourceStrings['nha.sa.guardianpreferencesquestion'] }}
						{{ appContent.schoolName }}?
						<span role="tooltip" id="guardianPreferencesTooltip" class="nha-tooltip">
							<span class="nha-tooltip-icon"></span>
							<span class="nha-tooltip-content">
								<span class="nha-tooltip-green-bar"></span>
								{{ appContent.resourceStrings['nha.sa.guardianpreferencestooltip'] }}
							</span>
						</span>
					</legend>
					<fieldset class="nha-form-radio nha-clear print-row">
						<div
							*ngFor="let enrollmentPreference of appContent.currentEnrollmentPreferences; let e = index"
							class="nha-gr-12 nha-gr-5@sm"
							[ngClass]="{ 'nha-clear': e % 2 == 0 }"
						>
							<div class="nha-form-group nha-inline-block">
								<input
									id="enrollmentPreference{{ e }}"
									formControlName="enrollmentPreferenceId"
									class="nha-input-radio"
									type="radio"
									value="{{ enrollmentPreference.enrollmentPreferenceID }}"
									[attr.aria-labelledby]="'guardianPreferencesQuestion enrollmentPreference' + e"
								/>
								<label for="enrollmentPreference{{ e }}">{{ enrollmentPreference.onlineApplicationShortName }}</label>
							</div>
						</div>
						<div class="nha-gr-12 nha-gr-5@sm">
							<div class="nha-form-group nha-inline-block">
								<input
									id="enrollmentPreferenceNone"
									formControlName="enrollmentPreferenceId"
									class="nha-input-radio"
									type="radio"
									value=""
									[attr.aria-labelledby]="'guardianPreferencesQuestion enrollmentPreferenceNone'"
								/>
								<label for="enrollmentPreferenceNone">{{ appContent.resourceStrings['nha.sa.guardianpreferencesnone'] }}</label>
							</div>
						</div>
					</fieldset>
				</div>
				<!-- Next Year Enrollment Preferences -->
				<div *ngIf="g === 0 && appContent.nextEnrollmentPreferences && this.academicYearApplying === appContent.nextAcademicYear" class="nha-row">
					<hr />
					<legend id="nextYearGuardianPreferencesQuestion" class="nha-gr-12" aria-describedby="guardianPreferencesTooltip">
						{{ appContent.resourceStrings['nha.sa.guardianpreferencesquestion'] }}
						{{ appContent.schoolName }}?
						<span role="tooltip" id="nextYearGuardianPreferencesQuestion" class="nha-tooltip">
							<span class="nha-tooltip-icon"></span>
							<span class="nha-tooltip-content">
								<span class="nha-tooltip-green-bar"></span>
								{{ appContent.resourceStrings['nha.sa.guardianpreferencestooltip'] }}
							</span>
						</span>
					</legend>
					<fieldset class="nha-form-radio nha-clear print-row">
						<div
							*ngFor="let enrollmentPreference of appContent.nextEnrollmentPreferences; let e = index"
							class="nha-gr-12 nha-gr-5@sm"
							[ngClass]="{ 'nha-clear': e % 2 == 0 }"
						>
							<div class="nha-form-group nha-inline-block">
								<input
									id="enrollmentPreference{{ e }}"
									formControlName="enrollmentPreferenceId"
									class="nha-input-radio"
									type="radio"
									value="{{ enrollmentPreference.enrollmentPreferenceID }}"
									[attr.aria-labelledby]="'guardianPreferencesQuestion enrollmentPreference' + e"
								/>
								<label for="enrollmentPreference{{ e }}">{{ enrollmentPreference.onlineApplicationShortName }}</label>
							</div>
						</div>
						<div class="nha-gr-12 nha-gr-5@sm">
							<div class="nha-form-group nha-inline-block">
								<input
									id="enrollmentPreferenceNone"
									formControlName="enrollmentPreferenceId"
									class="nha-input-radio"
									type="radio"
									value=""
									[attr.aria-labelledby]="'guardianPreferencesQuestion enrollmentPreferenceNone'"
								/>
								<label for="enrollmentPreferenceNone">{{ appContent.resourceStrings['nha.sa.guardianpreferencesnone'] }}</label>
							</div>
						</div>
					</fieldset>
				</div>
				<div *ngIf="g > 0" class="nha-row">
					<div class="nha-gr-12">
						<a (click)="removeGuardian(g)" (keydown.enter)="removeGuardian(g)" class="nha-warning-link" tabindex="0">
							<span class="fa fa-trash-o" aria-hidden="true"></span>
							{{ appContent.resourceStrings['nha.sa.removeadditionalguardian'] }}
						</a>
					</div>
				</div>
			</div>
			<hr />
			<div class="remove-for-print">
				<label *ngIf="guardians.controls.length < 2 && !schoolIsNY">
					{{ appContent.resourceStrings['nha.sa.secondguardianbenefits'] }}
					<span class="nha-tooltip">
						<span class="nha-tooltip-icon"></span>
						<span class="nha-tooltip-content">
							<span class="nha-tooltip-green-bar"></span>
							{{ appContent.resourceStrings['nha.sa.secondguardianbenefitstooltip'] }}
						</span>
					</span>
				</label>
				<button *ngIf="guardians.controls.length < 4 && !schoolIsNY" type="button" (click)="addGuardian()" class="nha-btn nha-btn-primary">
					{{ appContent.resourceStrings['nha.sa.addadditionalguardianbutton'] }}
				</button>
			</div>
		</div>
	</form>
</div>
